export const getStatusFOItems = (t) => ({
  Draf: {
    label: t('fleetTask.status.draft'),
    color: '#344264',
    backgroundColor: '#F0F2F6',
  },
  Dijadwalkan: {
    label: t('fleetTask.status.scheduled'),
    color: '#8F49DE',
    backgroundColor: '#F4EDFC',
  },
  Perjalanan: {
    label: t('fleetTask.status.started'),
    color: '#1C74DA',
    backgroundColor: '#DEEAFC',
  },
})
